// Tipos e utilidades de PROJETO compartilhados (seletor, sidebar e página de gestão).

export interface Project {
  id: string;
  name: string;
  logo_url?: string;
  color?: string;
  is_default: boolean;
  /** Trilho do projeto. IMUTÁVEL depois de criado (trigger no banco). */
  api_mode?: 'UNOFFICIAL' | 'OFFICIAL';
}

/** Projeto do trilho oficial (WhatsApp Cloud API) — sem QR; os números são instâncias espelho da Meta. */
export function isOfficial(p?: Project | null): boolean {
  return p?.api_mode === 'OFFICIAL';
}

export interface ProjectHealth {
  project_id: string;
  total: number;
  statuses: Record<string, number>;
}

export type Health = 'green' | 'yellow' | 'red' | 'gray';

/**
 * Semáforo de saúde da conexão de um projeto, a partir do resumo de status:
 * - cinza: sem números cadastrados;
 * - vermelho: algum número banido OU nenhum conectado;
 * - amarelo: algum conectado, mas há números conectando/aquecendo/aguardando QR;
 * - verde: todos conectados.
 */
export function healthOf(h?: ProjectHealth): Health {
  if (!h || h.total === 0) return 'gray';
  const s = h.statuses ?? {};
  const connected = s.connected ?? 0;
  if ((s.banned ?? 0) > 0 || connected === 0) return 'red';
  if (connected === h.total) return 'green';
  return 'yellow';
}

const DOT: Record<Health, string> = {
  green: 'bg-emerald-500',
  yellow: 'bg-amber-500',
  red: 'bg-rose-500',
  gray: 'bg-muted-foreground/40',
};

export function healthDotClass(h: Health): string {
  return DOT[h];
}
